module.exports = __webpack_public_path__ + "img/titles5.d64b72b9.png";